<header class="header">
<p class="booking-text">Prenota il tuo appuntamento presso la filiale credem</p>
</header>